import React from 'react'
import { PropTypes } from 'prop-types'
import { CtiImageCompound } from '../blogArticle/componentTypes/CtiImageCompound.jsx'
import { CtiLinkCompound } from '../blogArticle/componentTypes/CtiLinkCompound.jsx'
import './blogStatsAndColumns.css'

function BlogStatsAndColumns({ data = [] }) {
  const shouldDisplayInNarrowWidth = data.length <= 2
  return (
    <div
      className={`BlogStatColumn outerContainer u-posRelative u-sizeFull u-sizeConstrained u-sm-transformUp50 u-marginBottom6gu ${
        shouldDisplayInNarrowWidth ? 'u-sizeConstrainedNarrow' : ''
      }`}
    >
      <div className="u-flex u-flexWrap u-flexJustifyBetween u-sm-flexCol">
        {data.map((item, index) => {
          const {
            contentType,
            title = '',
            description = {},
            image = {},
            links = [],
          } = item
          const isBlogStat = contentType === 'cti:CTIBlogStat'
          return (
            <div
              key={index}
              className="item u-flex u-flexCol u-flexAlignItemsCenter u-flexAuto u-sizeFull u-sm-sizeFull u-md-size3of12 u-lg-size3of12 u-marginTop1gu u-marginRight4gu u-marginBottom4gu"
            >
              {image?.imageUrl ? (
                <CtiImageCompound
                  imageUrl={image?.imageUrl || ''}
                  alt={image?.alt || ''}
                  classNames="u-sm-posRelative u-sm-size6of12"
                  imgClasses="u-sizeFull u-paddingVert0"
                />
              ) : null}
              <div
                className={`u-flex u-flexCol u-flexAuto u-sizeFull u-marginTop2gu ${
                  isBlogStat ? 'u-flexAlignItemsCenter' : ''
                }`}
              >
                <div
                  className={`u-flex u-flexCol u-sizeFull u-sm-size3of4 u-md-size3of4 u-textBold ${
                    isBlogStat ? 'u-flexAlignItemsCenter' : ''
                  }`}
                >
                  {title &&
                    (isBlogStat ? (
                      <h1 className="u-textColorBrand u-textBold">{title}</h1>
                    ) : (
                      <h3 className="u-textColorBrand u-textBold">{title}</h3>
                    ))}
                </div>
                <div className="Content u-flex u-flexCol u-sizeFull u-flexAlignItemsCenter">
                  <p
                    dangerouslySetInnerHTML={{
                      __html: description?.value || '',
                    }}
                  ></p>
                </div>
                {links?.length > 0 ? (
                  <div
                    className={`u-flex u-flexCol u-flexAuto u-sizeFull u-flexAlignItemsStart u-textColorBrandLight`}
                  >
                    {links.map((el, index) => {
                      return (
                        <CtiLinkCompound
                          {...el}
                          key={index}
                          buttonClasses="u-textColorBrandLight u-decoBorderBrandLight"
                        />
                      )
                    })}
                  </div>
                ) : null}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

BlogStatsAndColumns.propTypes = {
  data: PropTypes.array,
}

export { BlogStatsAndColumns }
